<template>
  <div class="poster-article" v-loading="loading">
    <div class="view-html" id="htmlArea" v-if="show">
      <div class="top">
        <div class="img-f"><img :src="require('@/assets/images/logo_foot.png')" alt=""></div>
        <div class="line"></div>
        <p class="words">助力每个人实现自己的动画梦</p>
      </div>
      <div class="center-cont">
        <div class="info-ans">
          <div class="dotted"></div>
          <div class="info">
            <div class="img-f">
              <img :src="imgUrl" alt="">
            </div>
            <div class="name-chenghao">
              <p class="name over-ell">{{userName}}</p>
              <p class="chenghao over-ell">{{userSignature}}</p>
            </div>
          </div>
          <div class="ans">
            邀请您来回答
          </div>
        </div>
        <div class="huida-tit">
          <img class="icon-start" :src="require('@/assets/images/huida_post_icon01.jpg')" alt="">
          <div class="tit-cont">{{posterName}}</div>
          <div class="icon-end-f"><img class="icon-end" :src="require('@/assets/images/huida_post_icon02.jpg')" alt=""></div>
        </div>
        <!-- 普通问答 -->
        <!-- <div class="some-words">快来发布你的意见吧！</div> -->
        <!-- 悬赏问答 -->
        <div class="some-words" v-if="questionPrice>0">被评为最佳回答，即可获得 ￥{{ questionPrice }} 的悬赏红包，先回答，会更有优势！</div>
        <div class="qr-code-words">
          <table class="qr-code-show" id="qrcodeImgEl"></table>
          <p>长按二维码进入</p>
        </div>
      </div>
      <div class="outer">（长按分享好友）</div>
    </div>
    <div class="view-img" id="imageArea" v-if="imageShow">
      <img :src="img_url64" alt="">
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import axios from 'axios';
import vue from 'vue';
//import QRCode from 'qrcodejs2'
//import html2canvas from 'html2canvas'
vue.prototype.$axios = axios;
import qs from 'qs';
vue.prototype.qs = qs;
import VueCookies from 'vue-cookies'
import Vue from "vue";
vue.use(VueCookies);
import updateTdk from "@/utils/tdk";
export default {
  components: {

  },
  tdk() {
    return {
      title: this.headTitle,
      description: this.headDesc,
      keywords: this.headKeywords,
      ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
    };
  },
  data () {
    return {
      headTitle: "人人动画网【官网】",
      headKeywords: "keywords---rrdh",
      headDesc: "description---rrdh",
      isMounted: false, //for control not ssr render

      imageShow:false,
      show:true,

      id:'',
      imgUrl:"",
      description:'',
      showIndex: 0,
      posterName:"",
      posterImg: '',
      postUrl:'',
      posterImageUrl:'',
      img_url64:'',
      loading: true,
      userId:'',
      userName:'',
      userSignature:'',
      userIntroduction:'',
      questionPrice:0,
      questionId:"",
    }
  },
  serverPrefetch() {
    this.setSeo();
    updateTdk.call(this);
  },
  beforeMount() {
    const html2 = () => import('html2canvas')
    html2().then(res =>{
      Vue.prototype.html2canvas = res.default
    })
  },
  mounted() {
    this.isMounted = true;

    this.id=this.$route.query.id;
    this.questionId=this.$route.query.questionId;
    // this.getPoster(this.id);
     console.log(this.questionId)
    setTimeout(()=>{
      this.select (0)
      this.postUrl="http://www.renrendonghua.com/quedetail?id="+this.questionId+"&tem="+new Date().getMilliseconds();
    },300)

  },
  methods:{
    setSeo() {
      this.headTitle = "活动海报——人人动画网【官网】";
      this.headKeywords = "海报——人人动画网【官网】";
      this.headDesc =
          "海报——人人动画网【官网】";
    },
    select (index) {
      this.loading=true;
      this.showIndex = index
      console.log(index)
      this.$nextTick(()=>{
        this.createQrcode( this.postUrl,this.showIndex);
      });

    },
    createQrcode(text,index) {
      let _this=this;
      let url="/rrbi/poster/answer?id="+_this.id+"&ti="+new Date().getMilliseconds();
      _this.$axios.get(url).then(function(result){
        if(result.data.code==1){
          console.log(result)
          _this.posterName=result.data.response.answer.questionTitle;
          _this.description="";
          _this.posterImageUrl=result.data.response.answer.posterImageUrl;
          _this.questionPrice=result.data.response.answer.questionPrice;
          // _this.imgUrl="http://iss.21teacher.com/avatar/125/"+result.data.response.userInfo.userId+"/0.jpg";
          _this.imgUrl=result.data.response.answer.imgUrl;

          // _this.userId=result.data.response.userInfo.userId;
          _this.userName=result.data.response.userInfo.userName;
          _this.userSignature=result.data.response.userInfo.signature;
          _this.userIntroduction=result.data.response.userInfo.introduction;
          _this.questionId=result.data.response.answer.abswerto;

          _this.postUrl = "http://www.renrendonghua.com/quedetail?id="+_this.id+"&plate="+result.data.response.answer.belongSection+"&tem="+new Date().getMilliseconds();
          text  = _this.postUrl
        }else{
          _this.$router.push({
            path:'/error',
          })
        }
        const qrcodeImgEl = document.getElementById('qrcodeImgEl')
        qrcodeImgEl.innerHTML = ''
        let qrcode = new _this.QRCode(qrcodeImgEl, {
          width: 100,
          height: 100,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: _this.QRCode.CorrectLevel.H
        })
        qrcode.makeCode(text);

        setTimeout(function (){
          console.log("生成海报")
          // _this.createAppPoster();
          _this.createAppPoster();

        },"1000");
        // _this.$nextTick(()=>{
        //     console.log("生成海报")
        //
        // });
      })


    },
    createAppPoster() {
      let _this=this;
      // 生成海报
      const vm = this
      const domObj = document.getElementById('htmlArea')
      _this.html2canvas(domObj, {
        useCORS: true,
        allowTaint: false,
        logging: false,
        letterRendering: true,
        onclone(doc) {
          let e = doc.querySelector('#htmlArea')
          e.style.display = 'block'
        }
      }).then(function(canvas) {
        _this.$nextTick(()=>{

          _this.img_url64= canvas.toDataURL('image/png')
          // console.log("haibao64",_this.img_url64)
          _this.show=false;
          _this.imageShow=true;
          _this.loading=false;
        });

      }).catch(() => {
        console.log("出错了")
      });
    },
  },
}
</script>

<style scoped lang="less">
.poster-article{
  width: 100%;
  height: 100vh;
  .view-html{
    position: relative;
    padding: 10.27vh 18px 14.767676vh;
    width: 100%;
    height: 100%;
    background-image: url('../../../assets/images/post_wenda_bg.jpg');
    background-size: 100% 100%;
    .top{
      position: absolute;
      left: 0;
      top: 0;
      padding: 0 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 10.27vh;
      color: #d5d5d5;
      font-size: 14px;
      .img-f{
        height: 7vh;
        img{
          height: 100%
        }
      }
      .line{
        width: 1px;
        height: 5vh;
        background: #d4d6d5;
      }
      .words{
        margin: 5px 0;
        color: #d5d5d7;
        font-size: 14px;
      }
    }
    .center-cont{
      width: 100%;
      height: 100%;
      background: #fff;
      border-radius: 20px;
      .info-ans{
        position: relative;
        padding: 0 15px;
        height: 85px;
        .dotted{
          position: absolute;
          left: 0;
          bottom: -5px;
          width: 100%;
          height: 5px;
          background: url('../../../assets/images/dotted.png');
          background-repeat: repeat-x;
          background-size: 3px;
        }
        &:before,
        &:after{
          position: absolute;
          bottom: -5px;
          content: '';
          display: block;
          width: 10px;
          height: 10px;
          background: #00424b;
          border-radius: 50%;
        }
        &:before{
          left: -5px;
        }
        &:after{
          right: -5px;
        }
        .info{
          margin-top: 20px;
          float: left;
          width: 50%;
          .img-f{
            overflow: hidden;
            float: left;
            width: 35px;
            height: 35px;
            border-radius: 50%;
            img{
              width: 100%;
            }
          }
          .name-chenghao{
            margin-left: 40px;
            .name{
              color: #1e1e1e;
              font-size: 16px;
              font-weight: bold;
            }
            .chenghao{
              color: #808080;
              font-size: 14px;
            }
            .over-ell{
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
        .ans{
          float: left;
          padding-left: 45px;
          display: flex;
          align-items: center;
          width: 50%;
          height: 100%;
          color: #2ab7ef;
          font-size: 16px;
          background-image: url('../../../assets/images/wenda_tit_icon.jpg');
          background-repeat: no-repeat;
          background-size: 30px;
          background-position-y: center;
          background-position-x: 10px;
        }
      }
      .huida-tit{
        margin-top: 15px;
        padding: 0 15px;
        .icon-start{
          width: 40px;
        }
        .icon-end-f{
          text-align: right;
          .icon-end{
            display: inline-block;
            width: 35px;
          }
        }
        .tit-cont{
          margin: 5px 0;
          color: #4d4d4d;
          font-size: 22px;
          font-weight: bold;
        }
      }
      .some-words{
        padding: 0 15px;
        margin: 10px 0;
        text-align: center;
        color: #12aff2;
        font-size: 18px;
      }
      .qr-code-words{
        margin-top: 20px;
        .qr-code-show{
          margin: 0 auto;
          width: 100px;
          height: 100px;
          background: #f5f5f5;
        }
        p{
          margin-top: 5px;
          color: #817f80;
          font-size: 12px;
          text-align: center;
        }
      }
    }
    .outer{
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      line-height: 14.767676vh;
      color: #d5d5d5;
      text-align: center;
    }
  }
  .view-img{
    width: 100%;
    height: 100%;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
@media screen and (min-width: 750px){
  .poster-article{
    margin: 0 auto;
    width: 600px;
  }
}
@media screen and (max-width: 400px){
  .poster-article{
    .view-html{
      padding-bottom: 10vh;
      .bottom{
        bottom: 10vh;
      }
      .outer{
        line-height: 10vh;
      }
    }
  }
}
@media screen and (max-width: 350px){
  .poster-article{
    .view-html{
      .top{
        .words{
          font-size: 12px;
        }
      }
      .center-cont{
        .art-tit{
          margin-top: 10px;
          font-size: 16px;
        }
        .words{
          max-height: 44px;
          font-size: 12px;
        }
        .info-ans{
          .ans{
            font-size: 12px;
          }
        }
        .huida-tit{
          .icon-start{
            width: 20px;
          }
          .icon-end-f{
            .icon-end{
              width: 15px;
            }
          }
          .tit-cont{
            font-size: 16px;
          }
        }
        .some-words{
          font-size: 14px;
        }
      }
    }
  }
}
</style>
